function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "logo-oxy-arrecadacao",
  d: "M196.484,186.583a6.653,6.653,0,0,1-6.642-6.642h0a6.653,6.653,0,0,1,6.642-6.642h56.888V153.8H178.2v92.634h75.172V186.583Zm7.464,46.817h-7.071a6.948,6.948,0,0,1-7.035-6.285,6.628,6.628,0,0,1,6.642-7h7.071a6.948,6.948,0,0,1,7.035,6.285A6.648,6.648,0,0,1,203.948,233.4Zm0-19.962h-7.071a6.948,6.948,0,0,1-7.035-6.285,6.628,6.628,0,0,1,6.642-7h7.071a6.948,6.948,0,0,1,7.035,6.285A6.648,6.648,0,0,1,203.948,213.437Zm31.14,19.962h-7.071a6.948,6.948,0,0,1-7.035-6.285,6.628,6.628,0,0,1,6.642-7h7.071a6.948,6.948,0,0,1,7.035,6.285A6.627,6.627,0,0,1,235.088,233.4Zm0-19.962h-7.071a6.948,6.948,0,0,1-7.035-6.285,6.628,6.628,0,0,1,6.642-7h7.071a6.948,6.948,0,0,1,7.035,6.285A6.627,6.627,0,0,1,235.088,213.437Z",
  transform: "translate(-178.2 -153.8)"
});

const SvgLogoOxyArrecadacao = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 75.172,
    height: 92.634,
    viewBox: "0 0 75.172 92.634",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLogoOxyArrecadacao, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-oxy-arrecadacao.dfd9c5b0.svg";
export { ForwardRef as ReactComponent };